import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { authRedirectSave as authRedirectSaveAction } from '@/actions/AuthActions';
import { CustomNavigate } from '@/components/functional/Link/CustomNavigate/CustomNavigate';
import { notify } from '@/helpers/action';
import { useDidMount } from '@/hooks/lifecycle/useDidMount';
/**
 * リダイレクト用のカスタムコンポーネント
 * @description リダイレクト時にエラーメッセージの表示やリダイレクト先の保存などを行う
 * @param props
 * @returns
 */
export const CustomRedirect = (props) => {
    const { isSavePathForRedirect = false, message = '', state, to } = props;
    const { pathname } = useLocation();
    const dispatch = useDispatch();
    useDidMount(() => {
        if (message) {
            notify(message);
        }
        if (isSavePathForRedirect) {
            dispatch(authRedirectSaveAction(pathname));
        }
    });
    return _jsx(CustomNavigate, { replace: true, state: state, to: to });
};
